import React from "react";
import PasswordResetRequest from "../components/PasswordReset/PasswordResetRequest";

function PasswordResetScreen() {
  return (
    <div>
      <PasswordResetRequest />
    </div>
  );
}

export default PasswordResetScreen;